export const testimonials = [
  {
    id: 't-1',
    name: '阿灯',
    tag: '通勤围观党',
    content:
      '以前刷热榜总是东一块西一块，看完还是没头绪。这里会把脉络排好，午休十分钟就能跟上进度，省心。',
  },
  {
    id: 't-2',
    name: '小椿',
    tag: '线下活动常客',
    content:
      '进场、散场、寄存这些细节写得很实在。我照着调整了到场时间，果然没再排那么久的队。',
  },
  {
    id: 't-3',
    name: '老白',
    tag: '只看不说话的潜水员',
    content:
      '最大的感受是克制。只写看到的，不瞎猜，也不用被各种情绪牵着走，看着挺舒服。',
  },
  {
    id: 't-4',
    name: '柚子皮',
    tag: '内容搬运爱好者',
    content:
      '板块分得清楚，找某个活动的记录很快。标签点进去基本都能对得上，不会跳来跳去。',
  },
];